var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailCheckOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-Mail-check);\n      }\n\n      .cls-2 {\n        fill: #f9f9fc;\n      }\n\n      .cls-3 {\n        fill: #0b58a6;\n      }\n\n      .cls-4 {\n        fill: #3aa641;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mail-check"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail-check",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    className: "cls-2",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    className: "cls-3",
    d: "M16.186,5.543a.848.848,0,0,0-.076-.262.441.441,0,0,0-.019-.05c-.013-.021-.034-.032-.049-.051a.631.631,0,0,0-.1-.1.6.6,0,0,0-.1-.069.594.594,0,0,0-.122-.054.63.63,0,0,0-.128-.026.721.721,0,0,0-.076-.015H1.2A.682.682,0,0,0,.52,5.6v8.8a.683.683,0,0,0,.683.683H15.514A.683.683,0,0,0,16.2,14.4V5.6C16.2,5.577,16.188,5.561,16.186,5.543Zm-3.023.736L8.369,9.318l-4.9-3.039ZM1.886,13.717V6.9l6.128,3.8a.681.681,0,0,0,.725,0l6.092-3.862v6.879Z",
    transform: "translate(4.122 2.449)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321",
    transform: "translate(22.735 9.812)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    className: "cls-4",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(-7.735 -7.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    className: "cls-5",
    d: "M2.9,6.892a.465.465,0,0,1-.338-.146L.738,4.815a.464.464,0,0,1,.675-.638L2.856,5.7l2.223-3.02a.464.464,0,1,1,.748.551L3.274,6.7a.464.464,0,0,1-.346.188Z",
    transform: "translate(-6.636 -8.083)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCheckOutlined);
export default __webpack_public_path__ + "static/media/mail-check-outlined.20eab83fc16e6d117d164976ef9ebcaf.svg";
export { ForwardRef as ReactComponent };